import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';
import { MessageTemplate, RequestType } from '../Enum/common.enum';
import { MatRadioChange } from '@angular/material/radio';

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-send-document',
  templateUrl: './send-document.component.html',
  styleUrls: ['./send-document.component.scss']
})

export class SendDocumentComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  showAddButton = false;
  Module: string;

  closeShare: boolean = false;
  @Input() mainModuleName: string;
  @Output() closeShareFile3c = new EventEmitter<boolean>();
  clickEventsubscription: any;
  selectedFileList: any = [];
  timeout = null;  
  fileManagerIDs: any[];
  FileList: any[];
  UserList: any = [];

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;

  stateCtrSendlValue: any;

  stateCtrlValue: string;
  objectList: any = [];
  transactionID: any;
  addButtonShow: boolean = false;
  spinner:boolean=false;
  OfficeIDList: any = [];
  myOfficeID: any;
  stateCtrlSubject = new FormControl();
  menuModulesList: any = [] = [];

  constructor(private loaderService: LoaderService,private cdr: ChangeDetectorRef,private _dataSharingService: DataSharingService,
    private router: Router,private reusableClass: ReusableClasses,private encryptionAlgo: EncryptionService,
    private statusConst: StatusConstant,private settingsService: SettingService,private toastr: ToastrService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice())));
  }

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.mainModuleName;
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }
  }


  ngOnInit(): void {
    this.mainModuleName;   

    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];

    this.ShowAttchedToCore = false;
    this.ShowAttchedToContact = false;
    this.ShowAttchedToCompany = false;

    this.checkedAttachCore=false;
    this.checkedAttachContact=false;
    this.checkedAttachCompany=false;

    this.clickEventsubscription = this._dataSharingService.getSelectedFaxDocumentForFileManager().subscribe((result) => {
      if (result) {
        this.mainModuleName;
        this.selectedFileList = result;
        this.showAddButton = false;       
      }
    });
  }

  closeShareOpt(message: boolean) {
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];

    this.ShowAttchedToCore = false;
    this.ShowAttchedToContact = false;
    this.ShowAttchedToCompany = false;

    this.checkedAttachCore=false;
    this.checkedAttachContact=false;
    this.checkedAttachCompany=false;
    this.showAddButton = false;   
    this.stateCtrl.reset();  
    this.closeShareFile3c.emit(message);
  }

  cancelShareOpt(message: boolean) {
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];

    this.ShowAttchedToCore = false;
    this.ShowAttchedToContact = false;
    this.ShowAttchedToCompany = false;

    this.checkedAttachCore=false;
    this.checkedAttachContact=false;
    this.checkedAttachCompany=false;
    
    this.showAddButton = false;  
    this.closeShareFile3c.emit(message);   
    this.stateCtrl.reset();
  
    if (this.mainModuleName == "File Manager") {
      this._dataSharingService.sendClosePanelFaxForFileManager(true);
    }
  }
  

  removeDocument(document) {
    const index = this.selectedFileList.indexOf(document);
    if (index >= 0) {
      this.selectedFileList.splice(index, 1);      
      if (this.mainModuleName == "File Manager") {
        this._dataSharingService.sendRemoveFaxDocumentForFileManager(document);
      }
    }
    if (this.selectedFileList.length == 0) {
      this.showAddButton = false;
      this.closeShareOpt(false);      
      if (this.mainModuleName == "File Manager") {
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    }
  }  
  
  
  selectedCoreId:number=0;
  selectedContactId:number=0;
  selectedCompanyId:number=0;

  sendDocument() {
    if(this.ShowAttchedToCore==true){
      this.shareDocumentCore();
      return;
    }
    if(this.ShowAttchedToContact==true){
      this.shareDocumentContact();
      return;
    }
    if(this.ShowAttchedToCompany==true){
      this.shareDocumentCompany();
    }
  }

  shareDocumentCore() {  
    this.showAddButton=false;
    this.spinner=true;
    this.selectedFileList;   
    this.FileList = [];
    if (this.selectedFileList.length > 0) {
      this.transactionID = this.selectedFileList[0].transactionID;
      for (let i = 0; i < this.selectedFileList.length; i++) {       
        let file = {
          fileManagerID: this.selectedFileList[i].fileManagerItemID,
          placeholderType:1         
        }
        this.FileList.push(file);
      }
      this.fileManagerIDs = this.FileList;
    } else {
      this.fileManagerIDs = [];
    }
    
    var reqModel = {
      coreID: this.selectedCoreId,
      documentFolderID: 0,
      fileManagerIDs: this.fileManagerIDs,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID      
    }
    this.settingsService.addCorePlaceholdersWithDocuments(reqModel).subscribe(response => {
      if (response != undefined) {
        this.showAddButton=true;
        this.spinner=false;
        this.closeShareOpt(false);
        if (response.status == this.statusConst.statusSuccess) {          
          this.stateCtrlSubject.reset();          
          this.toastr.success('Core Document attached successfully.', '', {
            timeOut: 3000,
          });        
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
        else {
          this.showAddButton=true;
          this.spinner=false;         
          this.stateCtrlSubject.reset();        
          this.toastr.error('Core Document attached failed.', '', {
            timeOut: 3000,
          });
          this.closeShareOpt(false);
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
      } else {
        this.showAddButton=true;
        this.spinner=false;       
        this.stateCtrlSubject.reset();       
        this.toastr.error('Core Document attached failed.', '', {
          timeOut: 3000,
        });
        this.closeShareOpt(false);
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    });

  }

  shareDocumentContact() {  
    this.showAddButton=false;
    this.spinner=true;
    this.selectedFileList;   
    this.FileList = [];   
    if (this.selectedFileList.length > 0) {
      this.transactionID = this.selectedFileList[0].transactionID;
      for (let i = 0; i < this.selectedFileList.length; i++) {       
        let file = {
          fileManagerID: this.selectedFileList[i].fileManagerItemID,
          placeholderType:1         
        }
        this.FileList.push(file);
      }
      this.fileManagerIDs = this.FileList;
    } else {
      this.fileManagerIDs = [];
    }
    
    var reqModel = {
      contactID: this.selectedContactId,
      documentFolderID: 0,
      fileManagerIDs: this.fileManagerIDs,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID      
    }   
    this.settingsService.addContactPlaceholdersWithDocuments(reqModel).subscribe(response => {
      if (response != undefined) {
        this.showAddButton=true;
        this.spinner=false;
        this.closeShareOpt(false);
        if (response.status == this.statusConst.statusSuccess) {          
          this.stateCtrlSubject.reset();          
          this.toastr.success('Contact Document attached successfully.', '', {
            timeOut: 3000,
          });        
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
        else {
          this.showAddButton=true;
          this.spinner=false;         
          this.stateCtrlSubject.reset();        
          this.toastr.error('Contact Document attached failed.', '', {
            timeOut: 3000,
          });
          this.closeShareOpt(false);
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
      } else {
        this.showAddButton=true;
        this.spinner=false;       
        this.stateCtrlSubject.reset();       
        this.toastr.error('Contact Document attached failed.', '', {
          timeOut: 3000,
        });
        this.closeShareOpt(false);
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    });

  }

  shareDocumentCompany() {  
    this.showAddButton=false;
    this.spinner=true;
    this.selectedFileList;   
    this.FileList = [];  
    if (this.selectedFileList.length > 0) {
      this.transactionID = this.selectedFileList[0].transactionID;
      for (let i = 0; i < this.selectedFileList.length; i++) {       
        let file = {
          fileManagerID: this.selectedFileList[i].fileManagerItemID,
          placeholderType:1         
        }
        this.FileList.push(file);
      }
      this.fileManagerIDs = this.FileList;
    } else {
      this.fileManagerIDs = [];
    }
    
    var reqModel = {
      companyID: this.selectedCompanyId,
      documentFolderID: 0,
      fileManagerIDs: this.fileManagerIDs,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID:this.myOfficeID      
    }   
    this.settingsService.addCompanyPlaceholdersWithDocuments(reqModel).subscribe(response => {
      if (response != undefined) {
        this.showAddButton=true;
        this.spinner=false;
        this.closeShareOpt(false);
        if (response.status == this.statusConst.statusSuccess) {          
          this.stateCtrlSubject.reset();          
          this.toastr.success('Company Document attached successfully.', '', {
            timeOut: 3000,
          });        
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
        else {
          this.showAddButton=true;
          this.spinner=false;         
          this.stateCtrlSubject.reset();        
          this.toastr.error('Company Document attached failed.', '', {
            timeOut: 3000,
          });
          this.closeShareOpt(false);
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
      } else {
        this.showAddButton=true;
        this.spinner=false;       
        this.stateCtrlSubject.reset();       
        this.toastr.error('Company Document attached failed.', '', {
          timeOut: 3000,
        });
        this.closeShareOpt(false);
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    });

  }

  getplaceholdername(placeholdername) {
    if(placeholdername!=null && placeholdername!=undefined){
      var x = placeholdername;
      var f = x.replace(/\..+$/, '');
      return f;
    }   
  }

  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";

  ShowAttchedToCore: boolean = false;
  ShowAttchedToContact: boolean = false;
  ShowAttchedToCompany: boolean = false;


  attachedToCoreList: any = [] = [];
  attachedToContactList: any = [] = [];
  attachedToCompanyList: any = [] = [];


  attachedToSelectedCore: any = [] = [];
  attachedToSelectedContact: any = [] = [];
  attachedToSelectedCompany: any = [] = [];

  checkedAttachCore: boolean = false;
  checkedAttachContact: boolean = false;
  checkedAttachCompany: boolean = false;

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  roleIdList: any = [];

  selectCCC($event: MatRadioChange) {
    this.stateCtrl.reset();
    this.showAddButton=false;
    if ($event.value === 'Core') {
      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;      
    }
    if ($event.value === 'Contact') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;
      this.checkedAttachCompany = false;     
    }
    if ($event.value === 'Company') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = true;

      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = true;     
    }    
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];
  }


 //======================Core============================//

  searchCore(val) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }


  attchedToCoreSelected(coreSelected: any) {
    var checkCore = [];
    this.stateCtrl.setValue('');
    checkCore = this.attachedToSelectedCore;
    if (checkCore.length == 0) {
      this.selectedCoreId = coreSelected.coreID;
      var shortName = "";
      shortName = coreSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        coreID: coreSelected.coreID,
        email: coreSelected.email,
        name: coreSelected.name,        
        transactionID: coreSelected.transactionID,
        img: coreSelected.imageUrl,       
        shortName: shortName,
      }
      this.attachedToSelectedCore.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCore.length > 0) {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
      }   
  }  
 }

  // attchedToCoreSelected(coreSelected: any) {  
  //   this.stateCtrl.setValue('');
  //   let user = this.attachedToSelectedCore.find(m => m.transactionID == coreSelected.transactionID);   
  //   if (user == undefined || user == '' || user == null){
  //     var shortName = "";
  //     shortName = coreSelected.name.match(/\b(\w)/g).join('');
  //     var ReqModel = { 
  //       coreID: coreSelected.coreID,
  //       email: coreSelected.email,
  //       name: coreSelected.name,        
  //       transactionID: coreSelected.transactionID,
  //       img: coreSelected.imageUrl,       
  //       shortName: shortName,
  //     }
  //     this.attachedToSelectedCore.unshift(ReqModel);
  //     this.stateCtrl.reset();
  //     if (this.attachedToSelectedCore.length > 0) {
  //       this.showAddButton = true;
  //     } else {
  //       this.showAddButton = false;
  //     }   
  //   } else{
  //     this.addButtonShow = false;
  //     this.stateCtrl.reset();
  //   }
  // }

  attchedToRemoveCore(item: any) {   
    const index = this.attachedToSelectedCore.indexOf(item);
    if (index >= 0) {
      this.attachedToSelectedCore.splice(index, 1);
    }
    if (this.attachedToSelectedCore.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = false;
    }     
  }



  //======================Contact============================//

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }

  getsearchContact(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToContactList = response.data;
        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }


  attchedToContactSelected(contactSelected: any) {
    var checkContact = [];
    this.stateCtrl.setValue('');
    checkContact = this.attachedToSelectedContact;
    if (checkContact.length == 0) {
      this.selectedContactId = contactSelected.contactID;
      var shortName = "";
      shortName = contactSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,      
        transactionID: contactSelected.transactionID,
        img: contactSelected.imageUrl,       
        shortName: shortName,
      }
      this.attachedToSelectedContact.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedContact.length > 0) {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
      }   
  }  
 }

//   attchedToContactSelected(contactSelected: any) {
//     this.stateCtrl.setValue('');
//     let user = this.attachedToSelectedContact.find(m => m.transactionID == contactSelected.transactionID);   
//     if (user == undefined || user == '' || user == null){
//       var shortName = "";
//       shortName = contactSelected.name.match(/\b(\w)/g).join('');
//       var ReqModel = { 
//         contactID: contactSelected.contactID,
//         email: contactSelected.email,
//         name: contactSelected.name,      
//         transactionID: contactSelected.transactionID,
//         img: contactSelected.imageUrl,       
//         shortName: shortName,
//       }
//       this.attachedToSelectedContact.unshift(ReqModel);
//       this.stateCtrl.reset();
//       if (this.attachedToSelectedContact.length > 0) {
//         this.showAddButton = true;
//       } else {
//         this.showAddButton = false;
//       }   
//     } else{
//       this.addButtonShow = false;
//       this.stateCtrl.reset();
//     }   
// }


  attchedToRemoveContact(item: any) {
    const index = this.attachedToSelectedContact.indexOf(item);
    if (index >= 0) {
      this.attachedToSelectedContact.splice(index, 1);
    }
    if (this.attachedToSelectedContact.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = false;
    }     
  }





   //======================Company============================//

   searchCompany(val) {
    if (val.length >= 2) {
      this.attachedToCompanyList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCompany(val)
        }, 500);
      } else {
        this.attachedToCompanyList = [];
      }
    }
  }

  getsearchCompany(searchValue: any) {   
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
    if (SelectedCCC.length > 0) {
      this.CompanyfolderID = SelectedCCC[0].folderID;
    }

    this.roleIdList = [];

    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CompanyfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCompany(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCompanyList = response.data;
        } else {
          this.attachedToCompanyList = [];
        }
      }
    })
  }


  attchedToCompanySelected(companySelected: any) {
    var checkCompany = [];
    this.stateCtrl.setValue('');
    checkCompany = this.attachedToSelectedCompany;
    if (checkCompany.length == 0) {
      this.selectedCompanyId = companySelected.companyID;
      var shortName = "";
      shortName = companySelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        companyID: companySelected.companyID,
        email: companySelected.email,
        name: companySelected.name,       
        transactionID: companySelected.transactionID,
        img: companySelected.imageUrl,       
        shortName: shortName,
      }
      this.attachedToSelectedCompany.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCompany.length > 0) {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
      }   
  }  
  }

  // attchedToCompanySelected(companySelected: any) {
  //   this.stateCtrl.setValue('');
  //   let user = this.attachedToSelectedCompany.find(m => m.transactionID == companySelected.transactionID);   
  //   if (user == undefined || user == '' || user == null){
  //     var shortName = "";
  //     shortName = companySelected.name.match(/\b(\w)/g).join('');
  //     var ReqModel = { 
  //       companyID: companySelected.companyID,
  //       email: companySelected.email,
  //       name: companySelected.name,       
  //       transactionID: companySelected.transactionID,
  //       img: companySelected.imageUrl,       
  //       shortName: shortName,
  //     }
  //     this.attachedToSelectedCompany.unshift(ReqModel);
  //     this.stateCtrl.reset();
  //     if (this.attachedToSelectedCompany.length > 0) {
  //       this.showAddButton = true;
  //     } else {
  //       this.showAddButton = false;
  //     }   
  //   } else{
  //     this.addButtonShow = false;
  //     this.stateCtrl.reset();
  //   } 
  // }

  attchedToRemoveCompany(item: any) {
    const index = this.attachedToSelectedCompany.indexOf(item);
    if (index >= 0) {
      this.attachedToSelectedCompany.splice(index, 1);
    }
    if (this.attachedToSelectedCompany.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = false;
    }   
  }

      
}
